export default "__VITE_ASSET__745648c2__"